<template>
  <!--生命周期-->
  <div id="contentList" style="overflow-x: auto;">
    <div class="allSearch" style="margin-bottom: 0;overflow-x: auto;" >
      <div style="display: flex;height: 330px;">
        <div class="leftBox">
            <div class="selectBox" style="display: flex;align-items: center;width: 100%;">
              <div>
                <div class="myselectBox" style="display: flex;align-items: center;">
                  <span style="width: 100px;text-align: center;background-color: #ee1100;height: 30px;line-height: 30px;border-radius: 5px 0 0 5px;color: #fff;">BU</span>
                    <allSelect :multiple="true" :chooseData="buSelect" :needReturn="'buId'" :placeholder="'全部'" :matchValue="'buName'" :showValue="'{{buName}}'" v-model="postData.buId" v-on:on-change="getAllSelect" width="150">
                    </allSelect>
                    <el-button @click="registSelece('buId')" type="danger" icon="el-icon-close" size="mini" style="background-color: #ee1100;width: 30px;padding: 7px 0;" ></el-button>
                </div>

                <div style="width: 280px;margin-top:5px;height: 150px;border-radius: 5px;border: 1px solid #ccc;
                box-shadow: 2px 2px 10px rgba(200, 200, 200, 0.7); padding: 5px;box-sizing: border-box;overflow-y: auto;" >
                <div style="display: flex;flex-wrap:wrap;">
                  <span style="padding: 5px 10px;height: 18px;color: #ee1100;line-height: 18px;background-color: #FFF0F0;border-radius: 10px;margin: 5px;min-width: 70px;box-sizing: border-box;height: 30px;" v-for="(item,index) in showbuSelect" :key="index">{{ item.buName }}</span>
                </div>
                  
              </div>

              </div>

              <div style="margin-left: 15px;">
                <div class="myselectBox" style="display: flex;align-items: center;">
                  <span style="width: 100px;text-align: center;background-color: #ee1100;height: 30px;line-height: 30px;border-radius: 5px 0 0 5px;color: #fff;">【年】内容下架</span>
                    <allSelect :multiple="true" :chooseData="yearSelect" :needReturn="'id'" :placeholder="'全部'" :matchValue="'name'" :showValue="'{{name}}'" v-model="postData.year" v-on:on-change="getAllSelect" width="150">
                    </allSelect>
                    <el-button @click="registSelece('year')" type="danger" icon="el-icon-close" size="mini" style="background-color: #ee1100;width: 30px;padding: 7px 0;"></el-button>
                </div>

                <div style="width: 280px;margin-top:5px;height: 150px;border-radius: 5px;border: 1px solid #ccc; 
                box-shadow: 2px 2px 10px rgba(200, 200, 200, 0.7); padding: 5px;box-sizing: border-box;overflow-y: auto;" >

                  <div style="display: flex;flex-wrap: wrap;">
                    <span style="padding: 5px 10px;height: 18px;color: #ee1100;line-height: 18px;background-color: #FFF0F0;border-radius: 5px;margin: 5px;min-width: 70px;box-sizing: border-box;height: 30px;"  v-for="(item,index) in showyearSelect" :key="index">{{ item }}</span>
                  </div>

                 

              </div>


              </div>

              <div style="margin-left: 15px;">
                <div class="myselectBox" style="display: flex;align-items: center;">
                  <span style="width: 100px;text-align: center;background-color: #ee1100;height: 30px;line-height: 30px;border-radius: 5px 0 0 5px;color: #fff;">【月】内容下架</span>
                    <allSelect :multiple="true" :chooseData="monthSelect" :needReturn="'id'" :placeholder="'全部'" :matchValue="'name'" :showValue="'{{name}}'" v-model="postData.month" v-on:on-change="getAllSelect" width="150">
                    </allSelect>
                    <el-button  @click="registSelece('month')" type="danger" icon="el-icon-close" size="mini" style="background-color: #ee1100;width: 30px;padding: 7px 0;"></el-button>
                </div>

                <div style="width: 280px;margin-top:5px;height: 150px;border-radius: 5px;border: 1px solid #ccc; 
                box-shadow: 2px 2px 10px rgba(200, 200, 200, 0.7); padding: 5px;box-sizing: border-box;overflow-y: auto;" >

<div style="display: flex;flex-wrap: wrap;">
  <span style="padding: 5px 10px;height: 18px;color: #ee1100;line-height: 18px;background-color: #FFF0F0;border-radius: 5px;margin: 5px;min-width: 70px;box-sizing: border-box;height: 30px;" v-for="(item,index) in showmonthSelect" :key="index">{{ item }}</span>
</div>
                  
              </div>


              </div>

              <div style="margin-left: 15px;">
                <div class="myselectBox" style="display: flex;align-items: center;">
                  <span style="width: 100px;text-align: center;background-color: #ee1100;height: 30px;line-height: 30px;border-radius: 5px 0 0 5px;color: #fff;">产品/品牌</span>
                    <allSelect :multiple="true" :chooseData="brandSelect" :needReturn="'brandCode'" :placeholder="'全部'" :matchValue="'brandName'" :showValue="'{{brandName}}'" v-model="postData.brandCode" v-on:on-change="getAllSelect" width="150">
                    </allSelect>
                    <el-button type="danger" @click="registSelece('brandCode')" icon="el-icon-close" size="mini" style="background-color: #ee1100;width: 30px;padding: 7px 0;"></el-button>
                </div>
                <div style="width: 280px;margin-top:5px;height: 150px;border-radius: 5px;border: 1px solid #ccc;
                box-shadow: 2px 2px 10px rgba(200, 200, 200, 0.7); padding: 5px;box-sizing: border-box;overflow-y: auto;" >

                <div style="display: flex;flex-wrap: wrap;">
                  <span style="padding: 5px 10px;height: 18px;color: #ee1100;line-height: 18px;background-color: #FFF0F0;border-radius: 5px;margin: 5px;width: 120px;box-sizing: border-box;height: 30px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;  " v-for="(item,index) in showbrandSelect" :key="index" :title="item.brandName">{{ item.brandName }}</span>
                </div>
                  
              </div>

  
              </div>
                
            </div>

            <div class="showBox" style="display: flex;align-items: center;width: 100%;margin-top: 33px;justify-content: space-between;">
              <div style="width: 200px;height: 120px;border-radius: 10px;padding: 2px; border: 1px solid #ccc; /* 浅色边框 */
            box-shadow: 2px 2px 10px rgba(200, 200, 200, 0.7);">
                <div style="border-radius: 10px;background: linear-gradient(to bottom, rgba(246, 142, 133, 1), rgba(246, 142, 133, 0)); width: 100%;height: 100%;display: flex;flex-direction: column;text-align: center;justify-content: center;">
                  <span style="font-size: 18px;font-weight: 600;color: #fff;">
                    <img src="../../../assets/ly1.png" alt="" style="width: 46px;"/>
                    内容数量</span>
                  <span style="color: #ee1100;font-weight: 600;font-size: 22px; margin-top: 10px;font-style: italic;  ">{{ this.articleCount }}</span>
                </div>
              </div>

              <div style="width: 200px;height: 120px;border-radius: 10px;padding: 2px; border: 1px solid #ccc; 
            box-shadow: 2px 2px 10px rgba(200, 200, 200, 0.7);margin-left: 15px;">
                <div style="border-radius: 10px;background: linear-gradient(to bottom, rgba(246, 142, 133, 1), rgba(246, 142, 133, 0)); width: 100%;height: 100%;display: flex;flex-direction: column;text-align: center;justify-content: center;">
                  <span style="font-size: 18px;font-weight: 600;color: #fff;">
                    <img src="../../../assets/ly2.png" alt="" style="width: 50px;"/>平均转发次数</span>
                  <span style="color: #ee1100;font-weight: 600;font-size: 22px; margin-top: 10px;font-style: italic;">{{ this.shareRateAvg }}</span>
                </div>
              </div>

              <div style="width: 200px;height: 120px;border: 1px solid #ccc;border-radius: 10px;padding: 2px; border: 1px solid #ccc; 
            box-shadow: 2px 2px 10px rgba(200, 200, 200, 0.7);margin-left: 15px;">
                <div style="border-radius: 10px;background: linear-gradient(to bottom, rgba(246, 142, 133, 1), rgba(246, 142, 133, 0)); width: 100%;height: 100%;display: flex;flex-direction: column;text-align: center;justify-content: center;">
                  <span style="font-size: 18px;font-weight: 600;color: #fff;">
                    <img src="../../../assets/ly3.png" alt="" style="width: 50px;"/>平均阅读人数</span>
                  <span style="color: #ee1100;font-weight: 600;font-size: 22px; margin-top: 10px;font-style: italic;">{{ this.readCountAvg }}</span>
                </div>
              </div>

              <div style="width: 200px;height: 120px;border: 1px solid #ccc;border-radius: 10px;padding: 2px; border: 1px solid #ccc; 
            box-shadow: 2px 2px 10px rgba(200, 200, 200, 0.7);margin-left: 15px;">
                <div style="border-radius: 10px;background: linear-gradient(to bottom, rgba(246, 142, 133, 1), rgba(246, 142, 133, 0)); width: 100%;height: 100%;display: flex;flex-direction: column;text-align: center;justify-content: center;">
                  <span style="font-size: 18px;font-weight: 600;color: #fff;">
                    <img src="../../../assets/ly4.png" alt="" style="width: 46px;"/>
                    打开率</span> 
                  <span style="color: #ee1100;font-weight: 600;font-size: 22px; margin-top: 10px;font-style: italic;">{{ this.openRateAvg }}</span>
                </div>
              </div>

              <div style="width: 200px;height: 120px;border: 1px solid #ccc;border-radius: 10px;padding: 2px; border: 1px solid #ccc; 
            box-shadow: 2px 2px 10px rgba(200, 200, 200, 0.7);margin-left: 15px;">
                <div style="border-radius: 10px;background: linear-gradient(to bottom, rgba(246, 142, 133, 1), rgba(246, 142, 133, 0)); width: 100%;height: 100%;display: flex;flex-direction: column;text-align: center;justify-content: center;">
                  <span style="font-size: 18px;font-weight: 600;color: #fff;">
                    <img src="../../../assets/ly5.png" alt="" style="width: 56px;"/>
                    互动率</span>
                  <span style="color: #ee1100;font-weight: 600;font-size: 20px; margin-top: 10px;font-style: italic;">{{ this.interactionRateAvg }}</span>
                </div>
              </div>
            </div>

        </div>

        <div class="rightBox" style="flex:1;margin-left: 20px;padding: 5px;border-radius: 5px;border: 1px solid #ccc;
                box-shadow: 2px 2px 10px rgba(200, 200, 200, 0.7);">
          <div style="height: 28px;border-bottom: 1px solid #ccc;line-height: 26px;">
            <img src="../../../assets/miniicon.png" alt="" />
            智能广场</div>
          <div style="display: flex;align-items: center;width: 100%;justify-content: center;margin-top: 100px;">
            <button class="redButton" @click="xwmarek" style="display: flex;align-items: center;">
              <img src="../../../assets/xwlogo.png" alt="logo" width="20px" style="margin-right: 5px;"/>
              晓武创作</button>
            <span style="margin-left: 10px;">选择文章后点击该按钮，跳转到<br/>晓武用户端生成新内容</span>
          </div>
        </div>
      </div>

      <div class="newSearch d_flex" style="margin: 15px 0;">
        <div style="width: auto;white-space: normal;">
          <button class="redButton" @click="exportFile">
            导出
          </button>
        </div>

      </div>
    </div>
    <div class="allTablePlace" style="padding-top: 0;">
      <div style="overflow-x  : auto;">
        <table cellspacing="0" class="allTable">
                  <thead >
                  <tr>
                    <th width="5%">
                      <input @change="chooseAllData" v-model="selectAll" type="checkbox" class="allCheckbox" id="ALLchecked" name="checked"/>
                      <label for="ALLchecked"></label>
                    </th>
                    <th>ID</th>
                    <th>PromoMats审批编号</th>
                    <th>文章标题</th>
                    <th>文章类型</th>
                    <th>BU</th>
                    <th>产品/品牌</th>
                    <th>标签</th>
                    <th>内容方向</th>
                    <th>文章状态</th>
                    <th>总转发次数</th>
                    <th>总阅读次数</th>
                    <th>单推文章打开率</th>
                    <th>单推互动率</th>
                    <th>阅读时长</th>

                  </tr>
                  </thead>
                  <tbody>
                  <tr :key="index" v-for="(item, index) in myList">
                    <td width="5%">
                      <input @change="chooseUserInfo(item)" v-model="item.checked" type="checkbox" class="allCheckbox" :id="'userChecked' + index" name="checked"/>
                      <label :for="'userChecked' + index"></label>
                    </td>
                    <td class="NoWrap" style="max-width: 100px" :title="item.id">{{item.id}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.auditNo">{{item.auditNo}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.title">{{item.title}}</td>
                    <td width="" class="NoWrap" :title="item.type">{{item.type}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.buName">{{item.buName}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.brandName">{{item.brandName}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.tags">{{item.tags}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.direction">{{item.direction}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.state">{{item.state}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.shareCount">{{item.shareCount}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.readCount">{{item.readCount}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.openRate">{{item.openRate}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.interactionRate">{{item.interactionRate}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.readTime">{{item.readTime}}</td>
                  </tr>
                  </tbody>
                </table>
        <!-- <table cellspacing="0" class="allTable">
          <thead>
            <tr>
              <th>BU</th>
              <th>Brand</th>
              <th>更新时间</th>
              <th>创建人</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr :key="index" v-for="(item, index) in myList">
              <td>{{item.buName}}</td>
              <td>{{item.brandCN}}</td>
              <td>{{item.lastUpdateTime}}</td>
              <td>{{item.creator}}</td>
              <td class="colorBlue">
                <div class="icon more iconfont icongengduo moreOperations">
                  <ul>
                    <li @click="editContentType(item)">编辑</li>
                    <li @click="deleteType(item)">删除</li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table> -->
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage"
        :page="page" :explain="0"></page>
    </div>



  </div>
</template>

<script>
  export default {
    name: 'contentList',
    data() {
      return {
        baseUrl: process.env.config.baseUrl,
        newModel: false,
        newModel2:false,
        showModel: false,
        BUoptins:[],
        totalPage: 1,
        totalCount: 0,
        page: 1,
        cateModel: {
          BUName: '',
          BrandCode: ''
        },
        editModel:{
          BrandCode:'',
          BUName: '',
          BrandId: ''
        },
        allProduct: [],
        postData: {
          buId: null,
          brandCode:null,
          year:null,
          month:null,
          pageIndex: 1,
          pageSize: this.$commonJs.commonPageSize
        },
        myList: [],
        articleCount:'',
        interactionRateAvg:'',
        openRateAvg:'',
        readCountAvg:'',
        shareRateAvg:'',
        selectAll:false,
        mySelect:[],

        brandSelect:[],
        buSelect:[],
        monthSelect:[],
        yearSelect:[],
        showbrandSelect:[],
        showbuSelect:[],
        showmonthSelect:[],
        showyearSelect:[]
      }
    },
    created() {
      this.getList(1)
      this.getAllProDuct()
      // this.getAllSelect()
      this.getAllSelectDemo()

    },
    methods: {
      chooseAllData(){
        if(this.selectAll){
          this.myList.forEach(item=>{
            item.checked = true
          })
          this.mySelect = [...this.myList]
        }else{
          this.myList.forEach(item=>{
            item.checked = false
          })
          this.mySelect = []
        }
        
      },
      chooseUserInfo(item){
        if(item.checked){
          this.mySelect.push(item)
        }else{
          // 使用 filter 方法删除指定 id 的对象
        const filteredData = this.mySelect.filter(res => res.id !== item.id);
        this.mySelect = filteredData
        }
        console.log()
      },
      registSelece(type){
        switch (type) {
          case 'buId':
          this.postData.buId = null
          this.getAllSelect()
            break;
          case 'year':
          this.postData.year = null
          this.getAllSelect()
            break;
          case 'month':
          this.postData.month = null
          this.getAllSelect()
            break;
          case 'brandCode':
          this.postData.brandCode = null
          this.getAllSelect()
            break;
          default:
            break;
        }
      },
      
      deleteType(item) {
        this.$commonJs.doubleComfirm({
          content: '确定删除此BU？',
          successFun: msg => {
            this.$axiox.get('/api/BUController/DelteBU?BU_BrandId=' + item.bU_BrandId).then(msg => {
              this.$commonJs.alertTips({
                type: 'success',
                title: '成功',
                content: '删除成功',
                stayTime: 5
              })
              this.getList(1)
            })
          },
          errorFun: msg => {}
        })
      },
      getAllProDuct() {
        this.$axiox.get('/api/Dict/Get/brands').then(p => {
          this.allProduct = p
        })
      },
      getAllSelect(){
        const postdata = JSON.parse(JSON.stringify(this.postData))
        this.mySelect = []
        if(postdata.buId){
          postdata.buId = postdata.buId.split(',')
          const filteredArr = postdata.buId.filter(item => item !== "null"&&item !== null);
          postdata.buId = filteredArr.map(Number);
        }
        if(postdata.brandCode){
          postdata.brandCode = postdata.brandCode.split(',')
          const filteredArr = postdata.brandCode.filter(item => item !== "null"&&item !== null);
          postdata.brandCode = filteredArr
        }
        if(postdata.year){
          postdata.year = postdata.year.split(',')
          const filteredArr = postdata.year.filter(item => item !== "null"&&item !== null);
          postdata.year = filteredArr
        }
        if(postdata.month){
          postdata.month = postdata.month.split(',')
          const filteredArr = postdata.month.filter(item => item !== "null"&&item !== null);
          postdata.month = filteredArr
        }

        this.showbrandSelect=[]
        this.showbuSelect=[]
        this.showmonthSelect=[]
        this.showyearSelect=[]

        this.$axiox.post('/api/Article/article/LifeCycle/select',postdata).then(p => {
          console.log('xiala',p)
          this.showbrandSelect = p.brandSelect
            this.showbuSelect = p.buSelect
            this.showmonthSelect = p.monthSelect
            this.showyearSelect = p.yearSelect
            this.getList(1)
            this.page = 1
        })
      },
      getAllSelectDemo(){
        this.$axiox.post('/api/Article/article/LifeCycle/select',{
          buId:[],
          brandCode:[],
          year:[],
          month:[]
        }).then(p => {
          this.brandSelect = p.brandSelect
            this.buSelect = p.buSelect
            p.monthSelect.forEach(res=>{
              this.monthSelect.push({
                id:res,
                name:res,
                checked:false
              })
            })

            p.yearSelect.forEach(res=>{
              this.yearSelect.push({
                id:res,
                name:res,
                checked:false
              })
            })
            
            
            this.showbrandSelect = p.brandSelect
            this.showbuSelect = p.buSelect
            this.showmonthSelect = p.monthSelect
            this.showyearSelect = p.yearSelect

            this.getList(1)
            this.page = 1
        })
      },
      exportFile(){
        var xmlResquest = new XMLHttpRequest()
      if (window.XMLHttpRequest) { // Mozilla 浏览器
        xmlResquest = new XMLHttpRequest()
      } else {
        if (window.ActiveXObject) { // IE 浏览器
          try {
            // eslint-disable-next-line no-undef
            xmlResquest = new ActiveXObject('Microsoft.XMLHTTP')
          } catch (e) {
            // eslint-disable-next-line no-undef
            xmlResquest = new ActiveXObject('Msxml2.XMLHTTP')
          }
        }
      }
      const mydata = JSON.parse(JSON.stringify(this.postData))


      // mydata.buId = mydata.buId.replace('null,','').split(',').map(Number)
      // mydata.brandCode = mydata.brandCode.replace('null,','').split(',')
      if(!mydata.buId){
        mydata.buId = []
      }else{
        // mydata.buId = mydata.buId.replace('null,','').split(',').map(Number)
        let buid = []
         mydata.buId.split(',').forEach(res=>{
          if(res!==null&&res!=='null'){
            buid.push(Number(res))
          }
         })
         mydata.buId = buid
      }

      if(!mydata.brandCode){
        mydata.brandCode = []
      }else{
        // mydata.brandCode = mydata.brandCode.replace('null,','').split(',')
        let brandCode = []
         mydata.brandCode.split(',').forEach(res=>{
          if(res!==null&&res!=='null'){
            brandCode.push(res)
          }
         })
         mydata.brandCode = brandCode
      }

      if(!mydata.month){
        mydata.month = []
      }else{
        // mydata.month = mydata.month.replace('null,','').split(',')
        let month = []
         mydata.month.split(',').forEach(res=>{
          if(res!==null&&res!=='null'){
            month.push(res)
          }
         })
         mydata.month = month
      }

      if(!mydata.year){
        mydata.year = []
      }else{
        // mydata.year = mydata.year.replace('null,','').split(',')
        let year = []
         mydata.year.split(',').forEach(res=>{
          if(res!==null&&res!=='null'){
            year.push(res)
          }
         })
         mydata.year = year
      }
      
      

      
      if(this.mySelect.length){
        let ids = [] 
        this.mySelect.forEach(res=>{
          ids.push(res.id)
        })
        mydata.id = ids
      }
      let data = JSON.stringify(mydata)
      
      console.log(mydata)
      

      // let url = this.$commonJs.returnQuery(this.baseUrl + '/api/Article/article/LifeCycle/export', data)
      let url = this.baseUrl + '/api/Article/article/LifeCycle/export'
      xmlResquest.open('POST', url, true)
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.localStorage.getItem('TaToken'))
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        // var contentType = xmlResquest.getResponseHeader('Content-Type');
        // if(contentType==='application/json'){
        //   connom.alertTips({
        //         type: 'error',
        //         title: '错误',
        //         content: '仅可导出最大一个月时间的数据，请调整筛选条件后再尝试',
        //         stayTime: 5
        //       })
        //   return
        // }
        var content = xmlResquest.response
        var elink = document.createElement('a')
        elink.download = '生命周期列表.xlsx'
        elink.style.display = 'none'
        var blob = new Blob([content])
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink)
      }
      xmlResquest.send(data)
      },
      // 新建
      editToUrl() {
        this.newModel = true
        this.cateModel = {
          BUName: '',
          BrandCode: ''
        }
      },
      getList(pageIndex) {
        
        this.postData.pageIndex = pageIndex

        const postdata = JSON.parse(JSON.stringify(this.postData))
        if(postdata.buId){
          postdata.buId = postdata.buId.split(',')
          const filteredArr = postdata.buId.filter(item => item !== "null"&&item !== null);
          postdata.buId = filteredArr.map(Number)
        }
        if(postdata.brandCode){
          postdata.brandCode = postdata.brandCode.split(',')
          const filteredArr = postdata.brandCode.filter(item => item !== "null"&&item !== null);
          postdata.brandCode = filteredArr
        }
        if(postdata.year){
          postdata.year = postdata.year.split(',')
          const filteredArr = postdata.year.filter(item => item !== "null"&&item !== null);
          postdata.year = filteredArr

        }
        if(postdata.month){
          postdata.month = postdata.month.split(',')
          const filteredArr = postdata.month.filter(item => item !== "null"&&item !== null);
          postdata.month = filteredArr

        }

        this.$axiox.post('/api/Article/article/LifeCycle', postdata).then(msg => {
          
          console.log(msg)
          this.myList = msg.pageData.data
          this.totalCount = msg.pageData.total
          this.totalPage = Math.ceil(msg.pageData.total / this.postData.pageSize)
          this.articleCount=msg.articleCount,
          this.interactionRateAvg=msg.interactionRateAvg,
          this.openRateAvg=msg.openRateAvg,
          this.readCountAvg=msg.readCountAvg
          this.shareRateAvg = msg.shareRateAvg
          if(this.selectAll){
            this.myList.forEach(rows=>{
              rows.checked = true
            })
          }else{
            let selectId = []
          this.mySelect.forEach(res=>{
            selectId.push(res.id)
          })
          selectId.forEach(ids=>{
            this.myList.forEach(rows=>{
              if(rows.id===ids){
                rows.checked = true
              }
            })
          })
          }

          

        })
      },
      xwmarek(){
        let textid = []
        let textTitle = []
        this.mySelect.forEach(item=>{
          textid.push(item.id)
          textTitle.push(item.title)
        })
        const title = textTitle.join(',')
        const articleId = textid.join(',')
        // const tourl = `http://cnbejaigc-alb002-1981199672.cn-north-1.elb.amazonaws.com.cn:81/aiCreate?title=${title}&articleId=${articleId}`//开发环境
        // const tourl = `https://genai-uat.takeda.com.cn/aiCreate?title=${title}&articleId=${articleId}`//UAT环境
        const tourl = `https://genai.takeda.com.cn/aiCreate?title=${title}&articleId=${articleId}`//Prd环境
        console.log('tourl',tourl)

        if(textid.length){
          this.$axiox.post('/api/Article/article/LifeCycle/ai',textid).then(p => {  
            console.log('p',p,tourl)
            window.open(tourl, '_blank');
          })
        }else{
          this.$commonJs.alertTips({
              type: 'error',
              title: '提醒',
              content: '请先选择文章',
              stayTime: 5
            })
        }
      },
      selectCont() {
        this.getList(1)
      },
      confirModel() {
        if (!this.cateModel.BUName) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请输入分类名称',
            stayTime: 5
          })
          return
        }
        if (!this.cateModel.BrandCode) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请选择产品',
            stayTime: 5
          })
          return
        }

          this.$axiox.get('/api/BUController/AddBU?BUName='+this.cateModel.BUName + '&BrandCode='+this.cateModel.BrandCode).then(p => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '新建成功',
              stayTime: 5
            })
            this.getList(1)
            this.newModel = false
          })

      },
      
      confirModel2() {
        if (!this.editModel.BrandId) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请选择产品',
            stayTime: 5
          })
          return
        }

          this.$axiox.get('/api/BUController/UpdateBU?BU_BrandId='+this.editModel.BrandId + '&BrandCode='+this.editModel.BrandCode).then(p => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '编辑成功',
              stayTime: 5
            })
            this.getList(1)
            this.newModel2 = false
          })

      },
      selectEmpty() {
        this.postData = {
          buId: null,
          brandCode:null,
          year:null,
          month:null,
          pageIndex: 1,
          pageSize: this.$commonJs.commonPageSize
        }
        
      }
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/contentManger/lifecyclePage.vue